import { StyleSheet, Dimensions, Platform, } from 'react-native'
import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes'

const styles = StyleSheet.create({
    container: {
        flexGrow: 1,
        flexDirection: 'row',
        flexWrap: 'wrap',
    },
    option: {
        flex: 1,
        minHeight: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 95 : 65,
        minWidth: 100,
        margin: 4,
        padding: 8,
        borderRadius: 6,
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: Colors.brownGrey,
        backgroundColor: Colors.white,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    activeoption: {
        borderWidth: 2,
        borderColor: Colors.ocean,
    },
    title: {

    },
    activeTitle: {
        ...Fonts.type.bold,
    },
    desc: {
        color: Colors.smoothGrey,
    },
    activeDesc: {

    },
    firstLoader: {
        marginLeft: 0,
    },
    lastLoader: {
        marginRight: 0,
    },

})

export default styles
